import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class UpdateMagiisAccessCarrierProfile extends IRequestCommand<
  IUpdateMagiisAccessCarrierProfileResponse,
  ErrorDetails,
  IUpdateMagiisAccessCarrierProfileParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.PUT;

  override setParameters(parameters: IUpdateMagiisAccessCarrierProfileParameters) {
    this._commandBody = parameters;
    this.urlSections.push('magiisaccess');
    this.urlSections.push(`carrierprofile`);
    this.composeUrl();
  }
}

export interface IUpdateMagiisAccessCarrierProfileParameters extends ICommandParameters{
  id: number;
  carrierAccountId: string;
  name: string;
  description?: string;
  status?: string;
  creationUserId: string;
  updateUserId: string;
}

export interface IUpdateMagiisAccessCarrierProfileResponse extends ICommandResponse{

}
